import { Action, combineReducers } from 'redux';

import { metricsDataReducer } from './MetricsDataReducer';
import { metricsRefreshListReducer } from './MetricsRefreshListReducer';
import { MetricsDataState } from '../state/MetricsDataState';

export const metricsReducer: (state: MetricsDataState, action: Action) => MetricsDataState = combineReducers<MetricsDataState>({
  dataPointsById: metricsDataReducer,
  metricRefreshList: metricsRefreshListReducer
});